var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"hero-icons -helper--flex justify-center space-between"},_vm._l((_vm.props.data),function(item){return _c('div',{key:item.content,staticClass:"icon-box -helper--flex align-center column"},[_c('span',{staticClass:"icon-wrapper",class:item.iconClass}),_vm._v(" "),_c('p',{staticClass:"content-wrapper"},[_vm._v(_vm._s(item.content))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e077a6b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome/HeroIcons.vue
// module id = null
// module chunks = 